import React from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import { SeoType } from "@types/seo-type"
import { klipfolioPublisher, klipfolioAuthor, customAuthor } from "./common"
import { useSiteMetadata } from "@hooks/use-site-metadata"

function getWordCount(str) {
  return str.trim().split(/\s+/).length
}

const ArticleSchema = ({
  seo,
  body,
  image,
  date_updated,
  location,
}) => {
  const wordCount = body && getWordCount(body)
  const siteMetadata = useSiteMetadata()

  const schema = {
    "@id": location.buildHref,
    "@type": seo.schema_template === "article-how-to" ? "HowTo" : "NewsArticle",
    image: {
      url: seo.image?.cdn ?? image,
      "@type": "ImageObject",
    },
    author: seo.author
      ? customAuthor(seo.author, siteMetadata)
      : klipfolioAuthor(siteMetadata),
    "@context": "http://schema.org",
    headline: seo.title,
    description: seo.description,
    Speakable: {
      "@type": "SpeakableSpecification",
      xPath: ["//title", "/html/head/meta[@name='description']/@content"],
    },
    publisher: klipfolioPublisher,
    inLanguage: "en-US",
    dateModified: date_updated,
    datePublished: date_updated,
    mainEntityOfPage: location.buildHref,
  }

  if (seo?.schema) {
    Object.assign(schema, JSON.parse(seo.schema))
  }

  if (wordCount && seo.schema_template !== "article-how-to") {
    Object.assign(schema, { wordCount: wordCount })
  }

  return (
    <Helmet>
      <script type="application/ld+json">{`${JSON.stringify(schema)}`}</script>
    </Helmet>
  )
}

ArticleSchema.propTypes = {
  location: PropTypes.object.isRequired,
  seo: SeoType,
  body: PropTypes.string.isRequired,
  image: PropTypes.string,
  date_updated: PropTypes.string.isRequired,
}

export default ArticleSchema
